var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraficosLineal34X34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9159 8.5C21.9159 7.9132 22.3916 7.4375 22.9784 7.4375H28.5459C29.8068 7.4375 30.7984 8.45979 30.7984 9.69V15.2575C30.7984 15.8443 30.3227 16.32 29.7359 16.32C29.1491 16.32 28.6734 15.8443 28.6734 15.2575V11.0509L20.7689 18.9555C20.5697 19.1547 20.2994 19.2667 20.0176 19.2667C19.7358 19.2667 19.4656 19.1547 19.2663 18.9555L17.0143 16.7034L9.71891 23.9988C9.30398 24.4137 8.63124 24.4137 8.21631 23.9988C7.80138 23.5839 7.80138 22.9111 8.21631 22.4962L16.263 14.4495C16.4622 14.2503 16.7325 14.1383 17.0143 14.1383C17.2961 14.1383 17.5663 14.2503 17.7656 14.4495L20.0176 16.7016L27.1567 9.5625H22.9784C22.3916 9.5625 21.9159 9.0868 21.9159 8.5Z",
    fill: "#3677DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 3.1875C4.8368 3.1875 5.3125 3.6632 5.3125 4.25V28.6875H29.75C30.3368 28.6875 30.8125 29.1632 30.8125 29.75C30.8125 30.3368 30.3368 30.8125 29.75 30.8125H4.25C3.6632 30.8125 3.1875 30.3368 3.1875 29.75V4.25C3.1875 3.6632 3.6632 3.1875 4.25 3.1875Z",
    fill: "#3677DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraficosLineal34X34);
export default __webpack_public_path__ + "static/media/GRAFICOS_LINEAL_34X34.3522fd5e4f5386f0aa7c12b063645a4f.svg";
export { ForwardRef as ReactComponent };